'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../../../dist-es6/client/dtos/socketResponse');let

BaseForwardingAddressModalController=(_dec=




































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class BaseForwardingAddressModalController extends BaseController{constructor($modalInstance,socketService,uiCommandFactory,postResponseAction,notificationService,uncaughtErrorHandler,emailAddress=''){super(uncaughtErrorHandler);this._socketService=socketService;this._$modalInstance=$modalInstance;this._postResponseAction=postResponseAction;this._notificationService=notificationService;this._onSubmissionCommand=uiCommandFactory.makeForModal($modalInstance,this._onSubmission.bind(this));this._emailAddress=emailAddress;this.emailErrorHandler=this.emailErrorHandler.bind(this)}onCancel(){this._$modalInstance.dismiss()}get onSubmissionCommand(){return this._onSubmissionCommand}get submissionResult(){return this._submissionResult}async onSubmissionSocketAction(){throw new Error('Abstract!')}emailErrorHandler(submissionResult){if(_.exists(submissionResult)){if(_.exists(this._emailAddress)&&this._emailAddress.length>0&&submissionResult.status==='NotificationSettingsUpdateFailed'){return`Email address "${this._emailAddress}" is not valid.`}}}
async _onSubmission(){
this._submissionResult=await this.onSubmissionSocketAction();

if(!SocketResponse.succeeded(this._submissionResult)&&this._submissionResult.status==='NotificationSettingsUpdateFailed'){
return ModalSubmissionResult.KeepOpen;
}

await this._postResponseAction(this._submissionResult);
return ModalSubmissionResult.Close();
}

get emailAddress(){
return this._emailAddress;
}

set emailAddress(emailAddress){
this._emailAddress=emailAddress;
}},(_applyDecoratedDescriptor(_class.prototype,'_onSubmission',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_onSubmission'),_class.prototype)),_class));


module.exports=BaseForwardingAddressModalController;
//# sourceMappingURL=baseForwardingAddressModalController.js.map
